"use strict";
import { switchChainWithCleanup } from "hooks/switchChainRequest";
import { useAccount } from "hooks/useAccount";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { endSwitchingChain, startSwitchingChain } from "state/wallets/reducer";
import { trace } from "tracing/trace";
import { useIsSupportedChainIdCallback } from "uniswap/src/features/chains/hooks/useSupportedChainId";
import { isUniverseChainId } from "uniswap/src/features/chains/types";
import { useSwitchChain as useSwitchChainWagmi } from "wagmi";
export function useSwitchChain({ allowChainOutsideMode = false } = {}) {
  const dispatch = useDispatch();
  const isSupportedChainCallback = useIsSupportedChainIdCallback();
  const { switchChain } = useSwitchChainWagmi();
  const account = useAccount();
  return useCallback(
    (chainId) => {
      const isSupportedChain = allowChainOutsideMode ? isUniverseChainId(chainId) : isSupportedChainCallback(chainId);
      if (!isSupportedChain) {
        throw new Error(`Chain ${chainId} not supported for connector (${account.connector?.name})`);
      }
      if (account.chainId === chainId) {
        return void 0;
      }
      return trace(
        { name: "Switch chain", op: "wallet.switch_chain" },
        () => switchChainWithCleanup({
          chainId,
          onEnd: () => dispatch(endSwitchingChain()),
          onStart: () => dispatch(startSwitchingChain(chainId)),
          switchChain
        })
      );
    },
    [allowChainOutsideMode, isSupportedChainCallback, account.chainId, account.connector?.name, dispatch, switchChain]
  );
}
